// extracted by mini-css-extract-plugin
export default {"languagePicker":"DrawerMenu_languagePicker__4TuIe"};